/* =============================================================
   MyNacad — Thème Shopify Dawn natif
   JavaScript principal
   ============================================================= */
(function () {
  "use strict";

  /* ---------- Menu mobile ---------- */
  function initMobileMenu() {
    var burger = document.querySelector("[data-myna-burger]");
    var menu = document.querySelector("[data-myna-mobile-menu]");
    if (!burger || !menu) return;
    burger.addEventListener("click", function () {
      menu.classList.toggle("open");
      burger.classList.toggle("is-open");
      var expanded = menu.classList.contains("open");
      burger.setAttribute("aria-expanded", expanded ? "true" : "false");
    });
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq() {
    var items = document.querySelectorAll("[data-myna-faq-item]");
    items.forEach(function (item) {
      var btn = item.querySelector("[data-myna-faq-question]");
      if (!btn) return;
      btn.addEventListener("click", function () {
        var isOpen = item.classList.contains("open");
        items.forEach(function (other) { other.classList.remove("open"); });
        if (!isOpen) item.classList.add("open");
      });
    });
  }

  /* ---------- Reveal au scroll ---------- */
  function initReveal() {
    var reveals = document.querySelectorAll(".mynacad .reveal");
    if (!reveals.length) return;
    if (!("IntersectionObserver" in window)) {
      reveals.forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var delay = el.getAttribute("data-reveal-delay") || 0;
          setTimeout(function () { el.classList.add("is-visible"); }, parseInt(delay, 10) || 0);
          io.unobserve(el);
        }
      });
    }, { rootMargin: "-80px 0px", threshold: 0.1 });
    reveals.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Smooth scroll pour ancres ---------- */
  function initAnchors() {
    document.querySelectorAll(".mynacad a[href^='#']").forEach(function (link) {
      link.addEventListener("click", function (e) {
        var href = link.getAttribute("href");
        if (href === "#" || href.length < 2) return;
        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    });
  }

  /* ---------- Année copyright dynamique ---------- */
  function initYear() {
    document.querySelectorAll("[data-myna-year]").forEach(function (el) {
      el.textContent = new Date().getFullYear();
    });
  }

  function init() {
    initMobileMenu();
    initFaq();
    initReveal();
    initAnchors();
    initYear();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
